import { SIGN_UP_STEPS } from '../config/form-settings'

export const DEFAULT_SIGN_UP_PATH = SIGN_UP_STEPS['user-type'].path

/**
 * Resolves a URL segment to a configured signup step.
 *
 * React Router accepts any value for `:currentPage`. Checking for an own
 * property prevents malformed URLs (including inherited Object keys such as
 * `toString`) from being treated as valid signup steps.
 */
export function getSignUpStep (currentPage) {
  if (!Object.prototype.hasOwnProperty.call(SIGN_UP_STEPS, currentPage)) {
    return null
  }

  return SIGN_UP_STEPS[currentPage]
}
